import { FilterButton } from '../FilterButton';
import { typeFilters, types } from 'pages/LienKetVung/constants';

import './styles.scss';
import { FilterSelect } from '../FilterSelect';

export const Filters = ({
  currentType,
  onChangeType,
  currentAmenitiesFilters,
  currentTrafficFilters,
  onChangeAmenitiesFilters,
  onChangeTrafficFilters,
}) => {
  const filterItems = typeFilters[currentType] || [];

  const currentFilters =
    currentType === 'tien-ich'
      ? currentAmenitiesFilters
      : currentTrafficFilters;

  const isDesktop = window.innerWidth > 1024;
  const isMobile = window.innerWidth <= 450;

  const btnText = 'Hiện tất cả tiện ích';

  const handleChangeFilters = (e) => {
    const { id } = e.currentTarget.dataset;
    if (!id) {
      onChangeAmenitiesFilters(null);
      onChangeTrafficFilters(null);
      return;
    }
    if (currentType === 'tien-ich') {
      return onChangeAmenitiesFilters(id);
    }
    return onChangeTrafficFilters(id);
  };

  if (isDesktop) {
    return (
      <div className="vi-tri-filters desktop">
        <div className="vi-tri-switch">
          {types.map((type) => (
            <button
              key={type.id}
              className={`switch-button ${
                currentType === type.id ? 'active' : ''
              }`}
              onClick={() => onChangeType(type.id)}
            >
              {type.labelShort}
            </button>
          ))}
        </div>
        <div className="filters-container">
          <div className="filter-buttons-wrapper">
            <div className="filter-buttons">
              {filterItems.map((filter) => {
                const Icon = filter.icon;
                const isActive = currentFilters.includes(filter.id);
                return (
                  <FilterButton
                    id={filter.id}
                    key={filter.id}
                    label={filter.label}
                    icon={<Icon color={isActive ? '#F0B619' : '#fff'} />}
                    onChangeFilter={handleChangeFilters}
                    isActive={isActive}
                  />
                );
              })}
            </div>
          </div>
          <button
            className="show-all-button"
            // disabled={currentFilters.length === 0}
            onClick={handleChangeFilters}
          >
            {btnText}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="vi-tri-switch mobile">
        {types.map((type) => (
          <button
            key={type.id}
            className={`switch-button ${
              currentType === type.id ? 'active' : ''
            }`}
            onClick={() => onChangeType(type.id)}
          >
            {type.label}
          </button>
        ))}
      </div>
      <div className="vi-tri-filters mobile">
        <div className="filters-container">
          {isMobile ? (
            <FilterSelect
              filterItems={filterItems}
              currentFilters={currentFilters}
              onChangeFilter={handleChangeFilters}
            />
          ) : (
            <div className="filter-buttons">
              {filterItems.map((filter) => {
                const Icon = filter.icon;
                const isActive = currentFilters.includes(filter.id);
                return (
                  <FilterButton
                    id={filter.id}
                    key={filter.id}
                    label={filter.label}
                    icon={<Icon color={isActive ? '#F0B619' : '#737373'} />}
                    onChangeFilter={handleChangeFilters}
                    isActive={isActive}
                  />
                );
              })}
            </div>
          )}
          <button
            className="show-all-button"
            // disabled={currentFilters.length === 0}
            onClick={handleChangeFilters}
          >
            {btnText}
          </button>
        </div>
      </div>
    </>
  );
};
